import axios from "axios";

const url = process.env.REACT_APP_API_URL_SUPPLIER; 
const token = localStorage.getItem("token");
const api = axios.create({
  baseURL: url,
  headers: {
    Authorization: token ? `Bearer ${token}` : "",
  },
});

api.interceptors.request.use(
  (config) => {
    const newToken = localStorage.getItem("token");
    if (newToken) {
      config.headers["Authorization"] = `Bearer ${newToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

const getAllUpi = async () => {
  const res = await api.get(`/upi`);
  return res.data;
};

const getUpiById = async (id) => {
  const res = await api.get(`/upi/${id}`);
  return res.data;
};

const getUpiRegByUpiId = async (UPI_ID) => {
  const res = await api.get(`/upi-reg/${UPI_ID}`);
  return res.data;
};

const getAllSuppliers = async () => {
  const res = await api.get(`/suppliers`);
  return res.data;
};

const getSupplierWithRegisterById = async (id) => {
  const res = await api.get(`/reg-supplier/${id}`);
  return res.data;
};

const getUpiWithRegAndHaccp = async () => {
  const res = await api.get(`/upi/haccp`);
  return res.data;
};

const getUpiByIdWithHaccp = async (UPI_ID) => {
  const res = await api.get(`/upi/haccp/${UPI_ID}`);
  return res.data;
};

const createUpiSupplier = async (data) => {
  const res = await api.post(`/upi-supplier`, data);
  return res.data;
};

const getUpiHaccp = async (page, limit, search) => {
  const res = await api.get(`/getupihaccp?page=${page}&limit=${limit}&search=${search}`);
  return res.data;
};

const getUpiHaccpId = async (id) => {
  const res = await api.get(`/getupihaccp/id/${id}`);
  console.log("DATA ID:", id);
  return res.data;
};

const getUptAll = async () => {
  const res = await api.get(`/allupt`);
  return res.data;
};

const getSupplierByNoHaccp = async (value) => {
  const res = await api.get(`/nohaccp?value=${value}`);
  return res.data;
};
const deleteSupplierById = async (id) => {
  const res = await api.delete(`/delete/${id}`);
  return res.data;
}
export default {
  getAllUpi,
  getUpiById,
  getUpiRegByUpiId,
  getAllSuppliers,
  getUpiWithRegAndHaccp,
  getSupplierWithRegisterById,
  getUpiByIdWithHaccp,
  createUpiSupplier,
  getUpiHaccp,
  getUpiHaccpId,
  getUptAll,
  getSupplierByNoHaccp,
  deleteSupplierById
};
